import { useTranslation } from 'react-i18next';

import { Input } from 'src/components/ui/input';
import { cn } from 'src/lib/utils';

import { useForecastPaginatedTableEditableCell } from './hooks/useForecastPaginatedTableEditableCell';

type ForecastPaginatedTableEditableCellProps = {
  value: number;
  sku: string;
  monthId: string;
  onUpdate: (sku: string, monthId: string, value: number) => void;
  isHistory: boolean;
  editable: boolean;
};

export function ForecastPaginatedTableEditableCell({
  value,
  sku,
  monthId,
  onUpdate,
  isHistory,
  editable,
}: ForecastPaginatedTableEditableCellProps) {
  const {
    isEditing,
    editValue,
    position,
    inputRef,
    cellRef,
    handleDoubleClick,
    handleBlur,
    handleKeyDown,
    setEditValue,
  } = useForecastPaginatedTableEditableCell({
    value,
    sku,
    monthId,
    onUpdate,
    isHistory,
    editable,
  });
  const { t } = useTranslation('forecast');

  return (
    <>
      <div
        className={cn(
          'rounded-xs',
          editable &&
            'cursor-pointer select-none transition-colors duration-150 hover:bg-blue-50 hover:text-blue-600 dark:hover:bg-blue-950 dark:hover:text-blue-300',
        )}
        onDoubleClick={handleDoubleClick}
        ref={cellRef}
        title={t('Double-click to edit')}
      >
        {value}
      </div>

      {isEditing && (
        <div
          className='fixed z-50'
          style={{
            top: position.top - 10,
            left: position.left,
            transform: 'translateX(-24%)',
          }}
        >
          <Input
            className='h-10 w-32 text-center text-sm shadow-lg'
            min='0'
            onBlur={handleBlur}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyDown}
            ref={inputRef}
            step='0.01'
            type='number'
            value={editValue}
          />
        </div>
      )}
    </>
  );
}
